import { getLang } from "@ds/base";
import { EmptyHeader, Footer, FooterLink } from "@ds/components";
import { FlexLayout, Header, OliveDocuSignTheme, Theme } from "@ds/ui";
import "core-js/stable";
import React, { FunctionComponent } from "react";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import languages from "./common/Languages";
import Translate from "./common/Translate";
import ReportAbuse from "./components/ReportAbuse";


const SP_App: FunctionComponent<{}> = () => {
    const locales = Object.keys(languages);
    const locale = getLang() || 'en';
    const rebrandedLogoEnabled = window["rebrandedLogoEnabled"];

    const updateLocale = (newLang) => {
        const newLangParam = `&lang=${newLang}`;
        const existingLangParam = `&lang=${locale}`;

        if (location.href.indexOf(existingLangParam) > -1) {
            location.href = location.href.replace(existingLangParam, newLangParam);
        } else {
            location.href += newLangParam;
        }
    }

    const backgroundStyle: React.CSSProperties = {
         paddingBottom: "20px", background: "#666666", padding: "50px", height: "100%", justifyContent: "center", display: "flex",
    };

    if (rebrandedLogoEnabled) {
        backgroundStyle.marginTop = "50px";
    }

    return (
        <Theme docuSignTheme={OliveDocuSignTheme} enableFontFaceDeclarations enableGlobalCss>
            <Translate>
                <FlexLayout direction="column" alignItems="stretch">
                    <FlexLayout.Child>
                        {rebrandedLogoEnabled
                            ? <EmptyHeader rebrand2024={true} homeUrl="https://www.docusign.com" dark={false} />
                            : <Header fullWidth={true}>
                                <Header.Center>
                                    <Header.Logo href="https://www.docusign.com" />
                                </Header.Center>
                            </Header>
                        }
                    </FlexLayout.Child>
                    <FlexLayout.Child grow={true}>
                        <div style={backgroundStyle}>
                            <ReportAbuse />
                        </div>
                    </FlexLayout.Child>
                    <FlexLayout.Child>
                        <Footer
                            hidePoweredBy={false}
                            links={Footer.defaultFooterLinks}
                            currentLocale={locale}
                            onLocaleSelected={updateLocale}
                            locales={locales}
                            onLinkClicked={(segment: FooterLink) => { console.log(segment) }}
                            rebrand2024={rebrandedLogoEnabled}
                        />
                    </FlexLayout.Child>
                </FlexLayout>
            </Translate>
        </Theme >
    );
}

export default SP_App;
